import {useContext} from 'react';
import {Link, SubLink} from 'react-router-dom';
import { useRef } from 'react';
import { NavContainer, NavOption, SubOption, Navigation, Linky, HoverMenu} from './navigation.styles';

const NavigationComponent = () => {

    return (
        <NavContainer>
            <Navigation>
                <NavOption><Linky to="/">Home</Linky></NavOption>
                <NavOption>Porfolio Projects
                    <HoverMenu>
                        <SubOption><Linky to="/actual-play">Actual Plays</Linky></SubOption>
                        <SubOption><Linky to="/programming-projects">Coding Projects</Linky></SubOption>
                        <SubOption><Linky to="/craft-creations">Crafts</Linky></SubOption>
                    </HoverMenu>
                </NavOption>
                <NavOption><Linky to="/about-me">About Me</Linky>
                <HoverMenu>
                    <SubOption><Linky to="/contact">Contact</Linky></SubOption>
                </HoverMenu>
                </NavOption>
            </Navigation>
        </NavContainer>
    )
}

export default NavigationComponent;